export default __webpack_public_path__ + "static/media/project_gm_eshop_blur.fa9892d9.png";